export type FileHandlingStatus = "uploaded" | "ongoing" | "done";
export const fileAreaStatusOptions: {
  value: FileHandlingStatus;
  label: string;
}[] = [
  { value: "uploaded", label: "Uppladdad" },
  { value: "ongoing", label: "Pågående" },
  { value: "done", label: "Klar" },
];
